import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { SectionHeading } from "../styles/common/SectionHeading.style"
import { ContactInfo, DetailsWrapper, ImageWrapper, StyledContactForm, StyledContactSection } from "../styles/sections/ContactSection.styled"

export const ContactSection = () => {

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_v14nymp', 'template_e8cy4zv', form.current, 'iUtMJc3ALVLc50Obw')
        .then((result) => {
            console.log(result.text);
            console.log("message sent")
        }, (error) => {
            console.log(error.text);
        });
    };

    return (
        <>
        <StyledContactSection>    
            <SectionHeading>
                <h1>Contact</h1>
                <p>In touch</p>
            </SectionHeading>
            <DetailsWrapper>
                <ContactInfo>
                    <p>Hey there, friend! Got a question, comment, or just want to say hi? I'm all ears! Shoot me an email at insert email address here and let's get the conversation started. And don't worry, I promise to respond faster than a cheetah on roller skates which, if you haven't seen it before, is pretty darn fast. So don't be shy, drop me a line and let's connect!</p>
                    <p>
                        <i>Lets create an <strong>Experience</strong></i>
                    </p>
                    <div>
                        <a href="mailto:cprice2work@gmail.com">cprice2work@gmail.com</a>
                    </div>
                    <ImageWrapper>
                        <img src="./images/profile.jpg" alt="contact" />
                    </ImageWrapper>
                </ContactInfo>
                <StyledContactForm>
                <form ref={form} onSubmit={sendEmail}>
                    <label>Name</label>
                    <input type="text" name="user_name" />
                    <label>Email</label>
                    <input type="email" name="user_email" />
                    <label>Message</label>
                    <textarea name="message" />
                    <input type="submit" value="Send" />
                </form>
            </StyledContactForm>
            </DetailsWrapper>
            
        </StyledContactSection>
        <hr/>
        </>
    )
}